export const preAuthBtnStyle = {
    width: '250px', marginTop: '15px'
};

export const preAuthBtnStyleNormal = {
    width: '250px'
};